import { useEffect, useState } from 'react';

// const API_URL = 'http://localhost:5001/questions';
const API_URL = 'https://8c5ddb2de354.ngrok-free.app/questions';

export default function Quiz2() {
  const [questions, setQuestions] = useState([]);
  const [question, setQuestion] = useState('');
  const [options, setOptions] = useState('');
  const [correctAnswer, setCorrectAnswer] = useState('');
  const [loading, setLoading] = useState(false);

  // Fetch all questions
  const fetchQuestions = async () => {
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      setQuestions(data.data || []);
    } catch (error) {
      console.error('Failed to fetch questions', error);
    }
  };

  // Create a new question
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          question,
          options: options.split(',').map((o) => o.trim()),
          correctAnswer,
        }),
      });

      setQuestion('');
      setOptions('');
      setCorrectAnswer('');
      fetchQuestions();
    } catch (error) {
      console.error('Failed to create question', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuestions();
  }, []);

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: 'auto' }}>
      <h2>Create Question</h2>

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Question"
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          required
          style={{ width: '100%', marginBottom: '10px' }}
        />

        <input
          type="text"
          placeholder="Options (comma separated)"
          value={options}
          onChange={(e) => setOptions(e.target.value)}
          required
          style={{ width: '100%', marginBottom: '10px' }}
        />

        <input
          type="text"
          placeholder="Correct Answer"
          value={correctAnswer}
          onChange={(e) => setCorrectAnswer(e.target.value)}
          required
          style={{ width: '100%', marginBottom: '10px' }}
        />

        <button type="submit" disabled={loading}>
          {loading ? 'Saving...' : 'Add Question'}
        </button>
      </form>

      <hr />

      <h2>All Questions</h2>

      {questions.length === 0 && <p>No questions yet.</p>}

      <ul>
        {questions.map((q) => (
          <li key={q.id} style={{ marginBottom: '15px' }}>
            <strong>{q.question}</strong>
            <ul>
              {q.options.map((opt, i) => (
                <li key={i}>{opt}</li>
              ))}
            </ul>
            <small>Correct Answer: {q.correctAnswer}</small>
          </li>
        ))}
      </ul>
    </div>
  );
}
